import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

// Single tight-cropped horizontal lockup per theme. Scales cleanly via height.
export const WaldLogo = ({ className = "", size = "md" }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? "/brand/wald-lockup-dark.webp" : "/brand/wald-lockup-light.webp";
  const heights = { sm: "h-8", md: "h-10", lg: "h-14" };
  return (
    <Link
      to="/"
      data-testid="site-logo-link"
      aria-label="Wald Enterprise — Technology Partner for Agricultural Export"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={src}
        alt="Wald Enterprise — Technology Partner for Agricultural Export"
        width={2000}
        height={298}
        className={`${heights[size] || heights.md} w-auto object-contain`}
        loading="eager"
        decoding="async"
      />
    </Link>
  );
};

// W mark on its own — for favicon fallback contexts.
export const WaldMark = ({ className = "", size = 40 }) => (
  <img
    src="/brand/wald-mark-light.webp"
    alt="Wald"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    loading="lazy"
    decoding="async"
  />
);
